import * as React from 'react';
import classNames from 'classnames';
import { ArticleItemResponse } from '@/api/article/types';
import translations from '@/storybook/dummyData/translations';
import { Button } from '../Button';
import { Link } from '../Link';
import { LoadingBar } from '../LoadingBar';
import styles from './ArticleCard.module.scss';

export interface ArticleCardProps {
	readonly isSkeleton?: boolean;
	readonly isQuickSearch?: boolean;
	readonly article?: ArticleItemResponse;
}

/**
 * Generic ArticleCard component.
 */
export const ArticleCard: React.FunctionComponent<ArticleCardProps> = ({ isSkeleton, isQuickSearch, article }) => {
	return (
		<article>
			<Link
				className={classNames(styles.wrapper, {
					[styles.isQuickSearch]: isQuickSearch,
				})}
				to={article?.path ?? '#'}
			>
				<div className={styles.text}>
					{isSkeleton ? (
						<>
							<LoadingBar width={'50%'} height={'20px'} />
							<LoadingBar width={'100%'} height={'18px'} />
							<LoadingBar width={'100%'} height={'18px'} />
						</>
					) : (
						<>
							<h2 className={classNames(styles.name, 'u-ellipsis')}>{article?.name}</h2>
							<p className={styles.description}>{article?.shortDescription}</p>
						</>
					)}
				</div>
				<Button variant={'ghost'} className={styles.fakeLink}>
					{translations.shared.readMore}
				</Button>
			</Link>
		</article>
	);
};
